import { createContext } from "react";
import type { ObjectIdString } from "@Helpers/schemas/common.schema";

interface HoopsViewerContextType {
  /**
   * files.versions._id of the file open in the viewer (24-hex; `fileVersionId` on every request
   * schema). Absent when no file is mounted — i.e. outside a Provider, and on the default context.
   */
  fileVersionId?: ObjectIdString;
  fileVersionData?: any;
  viewerImpl: {
    hwv: any;
    loadMarkups?: any;
    activateOperator?: any;
    isLeafNode?: any;
    deleteModel?: any;
    loadModels?: any;
    setMarkupViewEditMode?: any;
    cuttingPlaneToggle?: any;
    resetViewer?: any;
    _operatorManager?: any;
    _cuttingPlaneController?: any;
    cuttingPlaneGeomVisibilityToggle?: any;
    cuttingPlaneModeToggle?: any;
    addPlaneHandles?: any;
    removePlaneHandles?: any;
    sectionBoxGeometryToggle?: any;
    _clippingBox?: any;
    sectionBoxScaleHandleToggle?: any;
    sectionBoxHandlesToggle?: any;
    sectionBoxToggle?: any;
    resetCuttingPlane?: any;
    _drawingManimulator?: any;
    unsetCallbacks?: any;
  } | null;
  isModelStructureReady: boolean;
  isSettingsApplied: boolean;
  socketDisconnected: boolean;
  HoopsModalStatus: any;
  selectedIssues: any;
  /** Issues._id of the issue open in the viewer (24-hex; `issueId` on every issues request schema). */
  currentViewIssueId: ObjectIdString | null | undefined;
  /** transmittals.versions._id (24-hex; `transmittalVersionId` on the issues request schemas). */
  transmittalVersionId: ObjectIdString | null | undefined;
  portalUnits?: {
    linearUnits: any[];
    areaUnits: any[];
    volumeUnits: any[];
  };
  handleClick?: any;
  handleKeyDown?: any;
  quantityTakeoffToolbar?: any;
}

export const HoopsViewerContext = createContext<HoopsViewerContextType>({
  // No file is mounted outside a Provider.
  fileVersionId: undefined,
  viewerImpl: null,
  isModelStructureReady: false,
  isSettingsApplied: false,
  socketDisconnected: false,
  HoopsModalStatus: {},
  selectedIssues: {},
  currentViewIssueId: undefined,
  transmittalVersionId: undefined,
  portalUnits: undefined,
});
